import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getImpactStoryPageData } from './api';
import type { ImpactStoryPageDataErrorCode } from './types';

export const {
	Context: ImpactStoryPageDataContext,
	Provider: ImpactStoryPageDataContextProvider,
	useContext: useImpactStoryPageData,
	useAsyncData: useImpactStoryPageDataFromApi,
	prefetchAsyncData: prefetchImpactStoryPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'ImpactStoryPageDataContext',
	dataProperty: 'pageData',
	getData: getImpactStoryPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<ImpactStoryPageDataErrorCode>(),
});
